import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_globe.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-52bd871d")

_pushScopeId("data-v-52bd871d")
const _hoisted_1 = { class: "relative bg-gray-lp-1000 rounded-lg px-2 pt-1 pb-2" }
const _hoisted_2 = { class: "text-12px xxl:text-14px text-gray-lp-300 font-semibold pb-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "self-center w-6 mr-2",
  alt: "globe-icon",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "flex text-gray-lp-300 text-16px font-semibold" }
const _hoisted_5 = { class: "ml-1" }
const _hoisted_6 = { class: "absolute border-l w-72 border-r flex flex-col bg-white rounded-lg shadow top-parent" }
const _hoisted_7 = { class: "border-b border-gray-lp-400" }
const _hoisted_8 = { class: "font-semibold text-16px p-4" }
const _hoisted_9 = { class: "cursor-pointer" }
const _hoisted_10 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_11 = { class: "text-14px font-medium text-gray-lp-300 col-span-3 text-left" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingV3.receiptLanguage")), 1),
    _createVNode("button", {
      class: "flex items-center cursor-pointer select-none",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleListAvailableLanguage && _ctx.toggleListAvailableLanguage(...args))),
      onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFocusListLanguage && _ctx.onFocusListLanguage(...args))),
      onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMouseDown = true)),
      onMouseup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isMouseDown = false)),
      style: {"height":"10px","width":"164px"},
      id: _ctx.id,
      tabindex: _ctx.showListAvailableLanguage ? -1 : 0
    }, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.activeLocale.name), 1),
      _createVNode("div", _hoisted_5, [
        _createVNode("img", {
          alt: "",
          class: "cursor-pointer select-none w-4",
          src: 
            require(`@/app/ui/assets/svg/${
              _ctx.showListAvailableLanguage ? 'chevron-up-new' : 'chevron-down-new'
            }.svg`)
          
        }, null, 8, ["src"])
      ])
    ], 40, ["id", "tabindex"]),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("bookingV3.receiptLanguage")), 1)
      ]),
      _createVNode("div", _hoisted_9, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableLanguage, (language, index) => {
          return (_openBlock(), _createBlock(_Fragment, { key: index }, [
            _hoisted_10,
            _createVNode("button", {
              ref: `changeLanguage-${index}`,
              onClick: ($event: any) => (_ctx.changeLanguageReceipt(language.value)),
              class: "grid grid-cols-4 p-4 w-full",
              onKeydown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onItemKeydown && _ctx.onItemKeydown(...args)))
            }, [
              _createVNode("img", {
                class: "self-center w-4",
                alt: language.flag,
                src: require(`@/app/ui/assets/svg/flag/${language.flag}.svg`)
              }, null, 8, ["alt", "src"]),
              _createVNode("div", _hoisted_11, _toDisplayString(language.name), 1)
            ], 40, ["onClick"])
          ], 64))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.showListAvailableLanguage]
    ])
  ], 512)), [
    [_directive_click_outside, _ctx.forceCloseListAvailableLanguage]
  ])
})